import { useMemo } from "react";
import { dimensionLabels, dimensionMeta } from "../constants";

export function useIqolGroups(raw) {
  return useMemo(() => {
    if (!raw) return { groups: [], report: {} };

    const grouped = raw.reduce((acc, { dimension, habito, valor }) => {
      if (valor == null) return acc;
      const dimLabel = dimensionLabels[dimension];
      if (!dimLabel) return acc;

      if (!acc[dimLabel]) {
        acc[dimLabel] = { dimension: dimLabel, habitos: [] };
      }
      acc[dimLabel].habitos.push({ nombre: habito, valor });
      return acc;
    }, {});

    Object.values(grouped).forEach((group) => {
      const order = Object.keys(dimensionMeta[group.dimension]?.habitos || {});
      const habitMap = Object.fromEntries(group.habitos.map(h => [h.nombre, h]));
      group.habitos = order.map(name => habitMap[name]).filter(Boolean);

      // Special formula for "Tus percepciones" dimension
      if (group.dimension === "Tus percepciones") {
        const valoracionPositiva = group.habitos.find(h => h.nombre === "Valoración positiva")?.valor;
        const valoracionNegativa = group.habitos.find(h => h.nombre === "Valoración negativa")?.valor;
        
        if (valoracionPositiva != null && valoracionNegativa != null) {
          group.average = Math.round((valoracionPositiva + (100 - valoracionNegativa)) / 2);
        } else {
          group.average = 0;
        }
      } else {
        // Standard average calculation for other dimensions
        const sum = group.habitos.reduce((s, h) => s + h.valor, 0);
        group.average = group.habitos.length ? Math.round(sum / group.habitos.length) : 0;
      }
    });

    const orderedGroups = Object.keys(dimensionMeta)
      .map(dimLabel => grouped[dimLabel])
      .filter(Boolean);

    const reportObj = Object.fromEntries(
      orderedGroups.map(({ dimension, average }) => [dimension, average])
    );

    return { groups: orderedGroups, report: reportObj };
  }, [raw]);
}
